// extracted by mini-css-extract-plugin
module.exports = {"setHeadline":"Toolset_setHeadline__Mmy3i","setIconsWrapper":"Toolset_setIconsWrapper__rfM3v","setIcon":"Toolset_setIcon__ePiUu","setText":"Toolset_setText__vYTC1"};